import { render, staticRenderFns } from "./ListFeedbacks.vue?vue&type=template&id=f6f1a198&scoped=true&"
import script from "./ListFeedbacks.vue?vue&type=script&lang=js&"
export * from "./ListFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./ListFeedbacks.vue?vue&type=style&index=0&id=f6f1a198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f1a198",
  null
  
)

export default component.exports